// extracted by mini-css-extract-plugin
module.exports = {"container":"AddressButton_container__RYtiW","label":"AddressButton_label__n2jcB","lightLabel":"AddressButton_lightLabel__wD_aP"};